/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Number_Of_CopiesInputs */

const en_number_of_copies = /** @type {(inputs: Number_Of_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of Copies`)
};

const es_number_of_copies = /** @type {(inputs: Number_Of_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de Copias`)
};

const fr_number_of_copies = /** @type {(inputs: Number_Of_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre d'exemplaires`)
};

const de_number_of_copies = /** @type {(inputs: Number_Of_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Exemplare`)
};

const ja_number_of_copies = /** @type {(inputs: Number_Of_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部数`)
};

const zh_number_of_copies = /** @type {(inputs: Number_Of_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`份数`)
};

const ar_number_of_copies = /** @type {(inputs: Number_Of_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عدد النسخ`)
};

const id_number_of_copies = /** @type {(inputs: Number_Of_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah Salinan`)
};

const it_number_of_copies = /** @type {(inputs: Number_Of_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di Copie`)
};

const ru_number_of_copies = /** @type {(inputs: Number_Of_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество Копий`)
};

const pt_number_of_copies = /** @type {(inputs: Number_Of_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de Cópias`)
};

const ko_number_of_copies = /** @type {(inputs: Number_Of_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부수`)
};

/**
* | output |
* | --- |
* | "Number of Copies" |
*
* @param {Number_Of_CopiesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const number_of_copies = /** @type {((inputs?: Number_Of_CopiesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Number_Of_CopiesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_number_of_copies(inputs)
	if (locale === "es") return es_number_of_copies(inputs)
	if (locale === "fr") return fr_number_of_copies(inputs)
	if (locale === "de") return de_number_of_copies(inputs)
	if (locale === "ja") return ja_number_of_copies(inputs)
	if (locale === "zh") return zh_number_of_copies(inputs)
	if (locale === "ar") return ar_number_of_copies(inputs)
	if (locale === "id") return id_number_of_copies(inputs)
	if (locale === "it") return it_number_of_copies(inputs)
	if (locale === "ru") return ru_number_of_copies(inputs)
	if (locale === "pt") return pt_number_of_copies(inputs)
	return ko_number_of_copies(inputs)
});